var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52148 10.667L5.35228 8.33812C5.87142 7.67774 6.8645 7.65613 7.41187 8.29331L9.02148 10.167M7.63151 8.54898C8.32295 7.66943 9.28638 6.42336 9.34905 6.34229L9.35571 6.33377C9.87578 5.67764 10.8657 5.65753 11.4119 6.29331L13.0215 8.16699M4.85482 3.16699H11.8548C12.5912 3.16699 13.1882 3.76395 13.1882 4.50033V11.5003C13.1882 12.2367 12.5912 12.8337 11.8548 12.8337H4.85482C4.11844 12.8337 3.52148 12.2367 3.52148 11.5003V4.50033C3.52148 3.76395 4.11844 3.16699 4.85482 3.16699Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImages);
export default __webpack_public_path__ + "static/media/Upload-images.3d028824eb8d9ad99074ad3c2cacb12f.svg";
export { ForwardRef as ReactComponent };